/**
 */
define('constant/blockpage/block.page.constant',[], function () {
    return {
        //0表示审核中 1表示审核通过  2表示审核不通过 3表示处理中 4自动审核不通过 5 手动作废
        claimStatusFilter: {
            '0': '应用认领正在审核中',
            '1': '已被其他开发者认领',
            '2': '应用认领审核未通过',
            '3': '应用认领正在处理中',
            '6': '应用认领成功',
            '4': '应用认领审核未通过',
            '5':'应用认领审核未通过'
        },
        claimMessageFilter: {
            '0': '应用认领正在审核中',
            '3': '应用认领正在处理中'
        }
    }
});

